/**
 * F5. Экзамен на права: три ситуации на перекрёстке, «ехать/ждать».
 * Цена экзамена, порог сдачи, риск аварии с правами и бонус к уровню
 * работы — написаны до начала.
 */
import { t } from '@life/i18n';
import { DRIVING_PASS_CORRECT, type DrivingChoice, type DrivingInput, type DrivingState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

const CHOICES: readonly DrivingChoice[] = ['go', 'wait'];

export function Driving({ state, onInput }: MinigameScreenProps<DrivingInput, DrivingState>) {
  const [picks, setPicks] = useState<(number | null)[]>(() => state.situations.map(() => null));
  const complete = picks.every((p) => p !== null);

  return (
    <>
      <p class="hint">
        {t('ui.minigame.driving.rules', {
          sum: money(state.cost),
          pass: DRIVING_PASS_CORRECT,
          total: state.situations.length,
          mult: state.accidentMult,
          bonus: state.levelBonus,
        })}
      </p>
      {state.situations.map((s, i) => (
        <div class="q" key={s.key} data-question={i}>
          <p class="q-text">{t(s.key)}</p>
          <Choice
            label={t(s.key)}
            items={CHOICES.map((c) => ({ text: t(`minigame.driving.${c}`) }))}
            value={picks[i] ?? null}
            onChange={(j) => setPicks(picks.map((p, k) => (k === i ? j : p)))}
          />
        </div>
      ))}
      <button
        type="button"
        class="btn accent block"
        disabled={!complete}
        onClick={() => onInput({ choices: picks.map((p) => CHOICES[p ?? 1] as DrivingChoice) })}
      >
        {t('ui.minigame.driving.submit')}
      </button>
    </>
  );
}
